module.exports = __webpack_public_path__ + "img/elasticbitcoin-PRICE-TARGET-OF-1-BTC.912f1fa0.svg";